import { Chain, mainnet, sepolia } from 'viem/chains'

type NetworkConfig = {
  chainId: number
  chainFeatures: string[]
  HASURA_GRAPHQL_ENDPOINT: string
  NEXTAUTH_SECRET: string
  HASURA_GRAPHQL_ADMIN_SECRET: string
  FLAGSHIP_URL: string
  RPC_PROVIDER: string
  chain: Chain
  PUBLIC_IMAGE_BASE_URL: string
  GENERATOR_BASE_URL: string
  RESERVOIR_BASE_URL_HTTP: string
  RESERVOIR_BASE_URL_WS: string
  MARKETPLACE_FEE_ADDRESS: string
  CORE_API_URL: string
}

type Config = {
  [key in 'mainnet' | 'sepolia' | 'sepoliaStaging']: NetworkConfig
}

// TODO: creat a base sepolia config for dev and staging
export const envConfig: Config = {
  sepolia: {
    chainId: 11155111,
    chain: sepolia,
    chainFeatures: [],
    HASURA_GRAPHQL_ENDPOINT: 'https://ab-dev-sepolia.hasura.app/v1/graphql',
    NEXTAUTH_SECRET: process.env.DEV_SEPOLIA_NEXTAUTH_SECRET ?? '',
    HASURA_GRAPHQL_ADMIN_SECRET: process.env.DEV_SEPOLIA_HASURA_GRAPHQL_ADMIN_SECRET ?? '',
    FLAGSHIP_URL: 'https://dev.artblocks.io',
    RPC_PROVIDER: process.env.NEXT_PUBLIC_SEPOLIA_JSON_RPC_PROVIDER_URL ?? '',
    PUBLIC_IMAGE_BASE_URL: 'https://art-blocks-core-v3-dev-sepolia.s3.amazonaws.com',
    GENERATOR_BASE_URL: 'https://generator.development.artblocks.io',
    RESERVOIR_BASE_URL_HTTP: 'https://api-sepolia.reservoir.tools',
    RESERVOIR_BASE_URL_WS: 'wss://api-sepolia.reservoir.tools',
    MARKETPLACE_FEE_ADDRESS: '0x22eff9b604065a00de1ff58fce7879fb343e8333',
    CORE_API_URL: 'https://core-api-dev.artblocks.io'
  },
  sepoliaStaging: {
    chainId: 11155111,
    chain: sepolia,
    chainFeatures: [],
    HASURA_GRAPHQL_ENDPOINT: 'https://ab-staging-sepolia.hasura.app/v1/graphql',
    NEXTAUTH_SECRET: process.env.STAGING_NEXTAUTH_SECRET ?? '',
    HASURA_GRAPHQL_ADMIN_SECRET: process.env.STAGING_SEPOLIA_HASURA_GRAPHQL_ADMIN_SECRET ?? '',
    FLAGSHIP_URL: 'https://artist-staging.artblocks.io',
    RPC_PROVIDER: process.env.NEXT_PUBLIC_SEPOLIA_JSON_RPC_PROVIDER_URL ?? '',
    PUBLIC_IMAGE_BASE_URL: 'https://art-blocks-core-v3-dev-sepolia.s3.amazonaws.com',
    GENERATOR_BASE_URL: 'https://generator.artist-staging.artblocks.io',
    RESERVOIR_BASE_URL_HTTP: 'https://api-sepolia.reservoir.tools',
    RESERVOIR_BASE_URL_WS: 'wss://api-sepolia.reservoir.tools',
    MARKETPLACE_FEE_ADDRESS: '0x22eff9b604065a00de1ff58fce7879fb343e8333',
    CORE_API_URL: 'https://core-api-staging.artblocks.io'
  },
  mainnet: {
    chainId: 1,
    chain: mainnet,
    chainFeatures: [],
    HASURA_GRAPHQL_ENDPOINT: 'https://data.artblocks.io/v1/graphql',
    NEXTAUTH_SECRET: process.env.MAINNET_NEXTAUTH_SECRET ?? '',
    HASURA_GRAPHQL_ADMIN_SECRET: process.env.HASURA_GRAPHQL_ADMIN_SECRET ?? '',
    FLAGSHIP_URL: 'https://artblocks.io',
    RPC_PROVIDER: process.env.NEXT_PUBLIC_JSON_RPC_PROVIDER_URL ?? '',
    PUBLIC_IMAGE_BASE_URL: 'https://artblocks-mainnet.s3.amazonaws.com',
    GENERATOR_BASE_URL: 'https://generator.artblocks.io',
    RESERVOIR_BASE_URL_HTTP: 'https://api.reservoir.tools',
    RESERVOIR_BASE_URL_WS: 'wss://api.reservoir.tools',
    MARKETPLACE_FEE_ADDRESS: '0xedb522a6e134cc0bda0195dbf9b05ec27771a8d4',
    CORE_API_URL: 'https://core-api.artblocks.io'
  }
}

const appEnv = process.env.NEXT_PUBLIC_CURRENT_ENV ?? ''
export const env =
  appEnv === 'prod' ? envConfig['mainnet'] : appEnv === 'staging' ? envConfig['sepoliaStaging'] : envConfig['sepolia']
